//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Motion.js";
import "../no/TaggedObject.js";
import "../no/Expression.js";
import "../no/Expression.js";
let d=[[[0,"RotateCsys",1,"CoordinateSystem",0],[0,"RotateCsysOvrCtrl",1,0],[0,"RotateEnable",1,0],[0,"RotateEnableOvrCtrl",1,0],[1,"RotateExpression",0,"Expression",0],[0,"RotateExpressionOvrCtrl",1,0],[0,"RotateType",1,0],[0,"RotateTypeOvrCtrl",1,0],[0,"RotateVector",1,"Direction",0],[0,"RotateVectorOvrCtrl",1,0],[0,"TranslateEnable",1,0],[0,"TranslateEnableOvrCtrl",1,0],[1,"TranslateExpression",0,"Expression",0],[0,"TranslateExpressionOvrCtrl",1,0],[0,"TranslateVector",1,"Direction",0],[0,"TranslateVectorOvrCtrl",1,0],[1,"WxExpression",0,"Expression",0],[0,"WxExpressionOvrCtrl",1,0],[1,"WyExpression",0,"Expression",0],[0,"WyExpressionOvrCtrl",1,0],[1,"WzExpression",0,"Expression",0],[0,"WzExpressionOvrCtrl",1,0]],[],[]];
SPLM.Motion.LinkInitialVelocity = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Motion.LinkInitialVelocity";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Motion.LinkInitialVelocity.AngularVelocityType = Object.freeze({
    "Magnitude" : "Magnitude", "Component" : "Component"});

export default SPLM;